import { Router } from '@angular/router';
import { renderOnly } from 'src/app/shared/feature-flags';

// Home for the render flow: the /render landing (House Lights, docs/render-v2-landing.md). Since
// 2026-10-16 it is the only one — the old landing is gone, and /render-demo, where this one stood
// beside it, redirects here. The wordmark, "Back to home", the step-1 chevron and a sign-out lead
// back to it. On a render-only site (`renderOnly`) it stands at the site's root.
export const RENDER_LANDING_URL = renderOnly ? '/' : '/render';

// A dialog's pane classes (styles.scss): the landing's card and ink through render-v2-pane
// (designer, 2026-10-13: the feedback box in #faf9f7). The overlay sits outside the page, so it
// cannot inherit them.
export function renderDialogPanes(pane: string): string[] {
  return ['render-dialog-pane', pane, 'render-v2-pane'];
}

export function goRenderHome(router: Router): void {
  router.navigateByUrl(RENDER_LANDING_URL);
}
